<template>
  <div class="locationsContainer" :class="expanded ? 'expanded' : 'collapsed'">
    <div>
      <span v-if="title || type" class="application-heading"
        >{{ title || type }}:</span
      >
      <span v-if="locations && locations.length > max" class="seeAllHolder">
        <a @click="expanded = !expanded">
          <span v-if="!expanded">SEE ALL</span>
          <span v-if="expanded">SEE LESS</span>
        </a>
      </span>
    </div>
    <div :class="`locationsList ${type}`">
      <span
        class="locationListing"
        v-for="location in locations"
        :key="location.code"
      >
        <DetailsListItemCountryChip
          v-if="type === 'countries'"
          class="locationCol"
          :name="location.name"
          :code="location.code.toUpperCase()"
          :flagUrl="location.flagUrl"
          :theme="theme"
        ></DetailsListItemCountryChip>

        <DetailsListItemWaterChip
          v-if="type === 'waters' && hasMaritimeAccess"
          class="locationCol"
          :name="location.name || location.code.toUpperCase()"
          :code="location.code.toUpperCase()"
          :theme="theme"
        ></DetailsListItemWaterChip>
      </span>
    </div>
  </div>
</template>

<script>
import { hasMaritimeAccess } from "@/services/user/user.service";
export default {
  name: "DetailsListItemLocations",
  props: {
    countries: {
      type: Array,
      default: () => [],
    },
    waters: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  components: {
    DetailsListItemCountryChip: () =>
      import("@/components/common/details/DetailsListItemCountryChip"),
    DetailsListItemWaterChip: () =>
      import("@/components/common/details/DetailsListItemWaterChip"),
  },
  data() {
    return {
      expanded: false,
      hasMaritimeAccess: hasMaritimeAccess(),
    };
  },
  computed: {
    type() {
      return this.countries.length
        ? "countries"
        : this.waters.length
        ? "waters"
        : null;
    },
    locations() {
      if (!this.type) {
        return [];
      }

      return this[this.type];
    },
    max() {
      return this.type === "countries" ? 5 : 2;
    },
  },
};
</script>

<style scoped>
.locationsContainer {
  width: 100%;
}
.locationsContainer.collapsed {
  height: 2.5lh;
  overflow: hidden;
}

.locationCol {
  margin-right: 2px;
}

.seeAllHolder {
  float: right;
}

.locationsList.countries {
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, 63px);
}

.locationsList.waters {
  width: auto;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.locationListing {
  padding-right: 2px;
  padding-bottom: 2px;
}
.application-heading {
  text-transform: capitalize;
}
</style>
